import React, { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { BackDrawerButton } from 'components/generic';
import { useTranslation } from 'react-i18next';

const BackToButton: FC = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const dir = i18n.dir() === 'ltr' ? 'left' : 'right';
  const isLtr = i18n.dir() === 'ltr';

  const handleBackToPrevRoute = () => {
    navigate(-1);
  };

  return (
    <Box onClick={handleBackToPrevRoute}>
      <Box sx={{ display: { xs: 'inline-flex', sm: 'none' } }}>
        <BackDrawerButton direction={dir} />
      </Box>
      <Button
        sx={{
          display: { xs: 'none', sm: 'inline-flex' },
          textTransform: 'inherit',
          fontSize: { xs: '14px', sm: '18px' },
          lineHeight: '21px',
          color: 'secondary.main',
        }}
        variant="text"
      >
        {isLtr ? (
          <ArrowBackIos color="secondary" />
        ) : (
          <ArrowForwardIos color="secondary" />
        )}
        <Typography
          sx={{
            fontSize: { xs: '14px', sm: '18px' },
            lineHeight: '21px',
            color: 'secondary.main',
            fontWeight: '500',
          }}
        >
          {t('back')}
        </Typography>
      </Button>
    </Box>
  );
};

export default BackToButton;
